"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_oidc_1 = require("redux-oidc");
var userManagerConfig = {
    client_id: 'smart-home-remote',
    redirect_uri: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : '') + "/signin-oidc",
    response_type: 'token id_token',
    scope: 'openid profile car-remote-api',
    authority: 'https://auth.fpsoftwares.com',
    silent_redirect_uri: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : '') + "/silent_renew.html",
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
};
var userManager = redux_oidc_1.createUserManager(userManagerConfig);
exports.default = userManager;
//# sourceMappingURL=user-manager.js.map